import { useEffect, useState } from 'react'
import { fetchKumuEmbedUrl } from '../api'
import LoadingView from './LoadingView'

export default function SceneMapPage() {
  const [url,   setUrl]   = useState<string | null>(null)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    fetchKumuEmbedUrl()
      .then((u) => u ? setUrl(u) : setError('Map URL is not configured'))
      .catch(() => setError('Failed to load map'))
  }, [])

  if (error) {
    return (
      <div style={{ flex: 1, padding: '24px' }}>
        <div style={{ padding: '10px 14px', background: '#450a0a', color: '#fca5a5', fontSize: '13px', borderRadius: '8px', border: '1px solid #7f1d1d' }}>
          ⚠ {error}
        </div>
      </div>
    )
  }

  if (!url) return <LoadingView />

  return (
    <iframe
      src={url}
      style={{ flex: 1, display: 'block', width: '100%', border: 'none' }}
      allowFullScreen
    />
  )
}
